import { SvgIcon } from '@mui/material';
import { ReactComponent as WalletSVG } from "./wallet-en.svg";

export default function IconAndroidWalletEN(props) {
  return <SvgIcon {...props} component={WalletSVG} viewBox="0 0 125 34" />;
}